module.exports = __webpack_public_path__ + "img/IMG_9512_L_Wood_MockedUp.d30dc9ed.jpg";